import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-branded-rules-benefits',
  templateUrl: './branded-rules-benefits.component.html',
  styleUrls: ['./branded-rules-benefits.component.scss']
})
export class BrandedRulesBenefitsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
